import ICommand from '../../../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../../../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../../../FrontApplet/FrontApplet';
import {
	ApplicationGetTypeRequest,
	ApplicationGetTypeResult,
	ApplicationGetVersionRequest,
	ApplicationGetVersionResult,
	ApplicationRequests,
	ApplicationUpgradeRequest,
	ApplicationUpgradeResult,
} from './applicationCommands';

export function handleManagementApplicationRequests(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<ApplicationRequests>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<ApplicationRequests>) => {
		switch (commandEvent.command.type) {
			case ApplicationGetTypeRequest:
				await dispatch<ApplicationGetTypeResult>({
					type: ApplicationGetTypeResult,
					applicationType: await frontApplet.management.app.getType(),
				});
				break;
			case ApplicationGetVersionRequest:
				await dispatch<ApplicationGetVersionResult>({
					type: ApplicationGetVersionResult,
					version: await frontApplet.management.app.getVersion(),
				});
				break;
			case ApplicationUpgradeRequest:
				await dispatch<ApplicationUpgradeResult>({
					type: ApplicationUpgradeResult,
					result: {},
				});
				await frontApplet.management.app.upgrade(commandEvent.command.version, commandEvent.command.baseUrl);
				break;
			default:
		}
	});
}
